// extracted by mini-css-extract-plugin
export default {"container":"V_oN2jBwNqh5YuWKsC99"};